import { createFileRoute } from '@tanstack/react-router'
import { requireModule, requirePermission } from '../../app/guards'
import { TaskReportPage } from '../../features/reports/task-report-page'
import { taskReportSearchSchema } from '../../features/reports/task-report-search'

export const Route = createFileRoute('/_app/task-report')({
  staticData: { crumb: 'taskReport' },
  validateSearch: taskReportSearchSchema,
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'tasks')
    requirePermission(context.session, 'tasks.reports')
  },
  component: TaskReportPage,
})
